var BuyAsGiftButtonView = (function (_checkoutSettings, _baseView) {
    return _baseView.extend({
        el: '@buyAsGiftButton',

		events: {
			'click': '_onClick'
        },

        initialize: function () {
            _.bindAll(this, '_update');
            var settings = _checkoutSettings.getBasketSettings();
            this.$el.toggleClass('hidden-block', !settings.GiftEnabled);

            this._switcher = this.model.deliveryModeSwitcher();
            
            if (settings.GiftEnabled) {
                this._switcher.on('change', this._update);
                this._update();
            }
        },

        _update: function () {
            var mode = this._switcher.get('BasketMode') || 0;
            this.$('@cancelDescription').toggleClass('hidden-block', mode !== 1);
            this.$('@arrowIcon').toggleClass('hidden-block', mode === 1);
        },

        _onClick: function (e) {
            e.preventDefault();
            var _currentMode = this._switcher.get('BasketMode');
            this._switcher.switch(_currentMode === 0 ? 1 : 0)
                .done(_.bind(function (data) {
                    data = data.Value;
                    if (data.BasketMode === 1) {
                        if (data.DeliveryAddress === null && !data.BillingAddress) {
                            (new AddDeliveryAddressDisplayCommand({})).invokeGiftAndBilling('checkout');
                        } else if (data.DeliveryAddress === null) {
                            (new AddDeliveryAddressDisplayCommand({})).invokeGift('checkout');
                        } else if (data.BillingAddress === null) {
                            (new AddDeliveryAddressDisplayCommand({})).invokeBilling('checkout');
                        }
                    }
                }, this));
        }
    });
})(CheckoutSettings, BaseView);